import { useParams } from "react-router-dom";
import { PersonasTab } from "@/components/experience/personas-tab";

export function ProjectPersonasPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return <PersonasTab projectId={id} />;
}
